// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_9c-0";
export var orangeButton = "_9c-1";